import React, { useState, useEffect, useRef } from 'react';
import { BarChart3, TrendingUp, DollarSign, Target, Users, Calendar, Zap, Award, Activity, Eye, EyeOff, Copy, Download, Instagram } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import html2canvas from 'html2canvas';

const STAKEMIND_LOGO_BASE64 = "data:image/jpeg;base64,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";

const AdminReports = () => {
  const { user, isAdmin } = useAuth();
  const [isPrivacyMode, setIsPrivacyMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [marketingData, setMarketingData] = useState('');
  const [downloading, setDownloading] = useState(false);
  
  // Refs para download
  const storyCardRef = useRef(null);
  
  // Estados para filtros de período
  const [selectedPeriod, setSelectedPeriod] = useState('all_time');
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  
  // Estados para dados reais
  const [allUsers, setAllUsers] = useState([]);
  const [allBets, setAllBets] = useState([]);
  const [allExpenses, setAllExpenses] = useState([]);
  const [stats, setStats] = useState({
    total_users: 0,
    active_users: 0,
    total_bets: 0,
    total_units: 0,
    green_bets: 0,
    red_bets: 0,
    void_bets: 0,
    cashout_bets: 0,
    total_volume: 0,
    total_profit: 0,
    win_rate: 0,
    roi: 0,
    total_expenses: 0
  });

  console.log('🔍 AdminReports - isAdmin:', isAdmin, 'user:', user);

  useEffect(() => {
    if (isAdmin) {
      console.log('🚀 Iniciando carregamento de dados (isAdmin confirmado)...');
      loadAllData();
    } else {
      console.log('⚠️ Aguardando isAdmin...', { isAdmin });
    }
  }, [isAdmin, selectedPeriod, customStartDate, customEndDate]);

  const getPeriodDates = () => {
    const now = new Date();
    let startDate, endDate;

    switch (selectedPeriod) {
      case 'current_month':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case 'last_month':
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        break;
      case 'last_3_months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 2, 1);
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case 'all_time':
        return null; // No filter
      case 'custom':
        if (customStartDate && customEndDate) {
          startDate = new Date(customStartDate);
          endDate = new Date(customEndDate);
        } else {
          return null;
        }
        break;
      default:
        return null;
    }

    return {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    };
  };

  const loadAllData = async () => {
    try {
      setLoading(true);
      console.log('📊 Carregando dados reais de todos os usuários...');
      console.log('🔗 Backend URL:', process.env.REACT_APP_BACKEND_URL);
      
      // Buscar todos os usuários (endpoint correto)
      const usersUrl = `${process.env.REACT_APP_BACKEND_URL}/api/users`;
      console.log('📡 Fetching:', usersUrl);
      
      const usersResponse = await fetch(usersUrl);
      
      console.log('📥 Response status:', usersResponse.status);
      console.log('📥 Response ok:', usersResponse.ok);
      
      let allUsersData = [];
      if (usersResponse.ok) {
        allUsersData = await usersResponse.json();
        console.log('📦 Raw users data:', allUsersData);
        setAllUsers(allUsersData);
        console.log(`👥 Usuários carregados: ${allUsersData.length}`);
      } else {
        console.error('❌ Erro ao carregar usuários:', usersResponse.status, usersResponse.statusText);
        const errorText = await usersResponse.text();
        console.error('❌ Response body:', errorText);
      }

      // Buscar todas as apostas de todos os usuários
      let allBetsData = [];
      let allExpensesData = [];
      
      console.log(`🔄 Carregando dados de ${allUsersData.length} usuários...`);
      
      for (const userData of allUsersData) {
        try {
          // Buscar apostas do usuário
          const betsResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bets?user_id=${userData.id}`);
          if (betsResponse.ok) {
            const userBets = await betsResponse.json();
            allBetsData = [...allBetsData, ...userBets];
            console.log(`  ✅ Usuário ${userData.email}: ${userBets.length} apostas`);
          } else {
            console.error(`  ❌ Erro ao carregar apostas do usuário ${userData.email}`);
          }

          // Buscar despesas do usuário
          const expensesResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/expenses?user_id=${userData.id}`);
          if (expensesResponse.ok) {
            const userExpenses = await expensesResponse.json();
            allExpensesData = [...allExpensesData, ...userExpenses];
          }
        } catch (error) {
          console.error(`❌ Erro ao carregar dados do usuário ${userData.id}:`, error);
        }
      }

      setAllBets(allBetsData);
      setAllExpenses(allExpensesData);
      
      console.log(`🎯 Total de apostas carregadas: ${allBetsData.length}`);
      console.log(`💰 Total de despesas carregadas: ${allExpensesData.length}`);

      // Filtrar por período antes de calcular
      const periodDates = getPeriodDates();
      let filteredBets = allBetsData;
      let filteredExpenses = allExpensesData;

      if (periodDates) {
        const start = new Date(periodDates.startDate);
        const end = new Date(periodDates.endDate);
        
        filteredBets = allBetsData.filter(bet => {
          const betDate = new Date(bet.date);
          return betDate >= start && betDate <= end;
        });

        filteredExpenses = allExpensesData.filter(expense => {
          const expenseDate = new Date(expense.date);
          return expenseDate >= start && expenseDate <= end;
        });

        console.log(`📅 Período filtrado: ${periodDates.startDate} a ${periodDates.endDate}`);
        console.log(`🎯 Apostas filtradas: ${filteredBets.length}`);
      }

      // Calcular estatísticas reais com dados filtrados
      const calculatedStats = calculateRealStats(allUsersData, filteredBets, filteredExpenses);
      setStats(calculatedStats);
      
      console.log('📊 Stats calculados:', {
        total_users: calculatedStats.total_users,
        total_bets: calculatedStats.total_bets,
        total_units: calculatedStats.total_units,
        green_bets: calculatedStats.green_bets,
        total_volume: calculatedStats.total_volume,
        total_profit: calculatedStats.total_profit,
        roi: calculatedStats.roi.toFixed(2) + '%',
        win_rate: calculatedStats.win_rate.toFixed(2) + '%'
      });

      // Gerar dados de marketing baseados nos dados reais
      generateMarketingData(calculatedStats, allUsersData, filteredBets);
      
    } catch (error) {
      console.error('❌ Erro geral ao carregar dados:', error);
      console.error('❌ Error stack:', error.stack);
      console.error('❌ Error message:', error.message);
      alert('Erro ao carregar dados: ' + error.message + '. Verifique o console para mais detalhes.');
    } finally {
      setLoading(false);
    }
  };

  const calculateRealStats = (users, bets, expenses) => {
    const totalUsers = users.length;
    const activeUsers = users.filter(u => {
      const lastLogin = u.last_login ? new Date(u.last_login) : new Date(u.created_at);
      const daysSinceLastLogin = (new Date() - lastLogin) / (1000 * 60 * 60 * 24);
      return daysSinceLastLogin <= 30; // Usuários ativos nos últimos 30 dias
    }).length;

    const totalBets = bets.length;
    const greenBets = bets.filter(b => b.result === 'green').length;
    const redBets = bets.filter(b => b.result === 'red').length;
    const voidBets = bets.filter(b => b.result === 'void').length;
    const cashoutBets = bets.filter(b => b.result === 'cashout').length;

    const totalVolume = bets.reduce((sum, bet) => sum + (bet.stake || 0), 0);
    
    // Unidades líquidas = soma das unidades das apostas GREEN (ganhas)
    const totalUnits = bets
      .filter(b => b.result === 'green')
      .reduce((sum, bet) => sum + (bet.units || 1), 0);
    
    console.log('📊 Cálculo de Unidades:');
    console.log('  Total de apostas:', bets.length);
    console.log('  Apostas GREEN:', bets.filter(b => b.result === 'green').length);
    console.log('  Total Units calculado:', totalUnits);
    
    const totalProfit = bets.reduce((sum, bet) => sum + (bet.profit || 0), 0);
    const totalExpenses = expenses.reduce((sum, expense) => sum + (expense.amount || 0), 0);
    
    const winRate = totalBets > 0 ? (greenBets / totalBets) * 100 : 0;
    const roi = totalVolume > 0 ? (totalProfit / totalVolume) * 100 : 0;

    return {
      total_users: totalUsers,
      active_users: activeUsers,
      total_bets: totalBets,
      total_units: totalUnits,
      green_bets: greenBets,
      red_bets: redBets,
      void_bets: voidBets,
      cashout_bets: cashoutBets,
      total_volume: totalVolume,
      total_profit: totalProfit,
      total_expenses: totalExpenses,
      win_rate: winRate,
      roi: roi
    };
  };

  const generateMarketingData = (stats, users, bets) => {
    const avgMonthlyRevenue = (stats.total_volume * 0.05); // Assumindo 5% de comissão
    const lifetimeValue = users.length > 0 ? (avgMonthlyRevenue / users.length * 12) : 0;
    const avgTicket = stats.total_bets > 0 ? (stats.total_volume / stats.total_bets) : 0;

    const marketingText = `🎯 RELATÓRIO EXECUTIVO REAL - STAKEMIND ${new Date().getFullYear()}

📊 DADOS REAIS DA PLATAFORMA:
• Total de Usuários: ${stats.total_users.toLocaleString('pt-BR')}
• Usuários Ativos (30 dias): ${stats.active_users.toLocaleString('pt-BR')} (${stats.total_users > 0 ? ((stats.active_users/stats.total_users)*100).toFixed(1) : 0}% retenção)
• Total de Apostas Registradas: ${stats.total_bets.toLocaleString('pt-BR')}
• Volume Real Movimentado: R$ ${stats.total_volume.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
• Receita Estimada: R$ ${avgMonthlyRevenue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}

🔥 PERFORMANCE REAL DOS USUÁRIOS:
• Taxa de Acerto Geral: ${stats.win_rate.toFixed(1)}%
• ROI Médio da Base: ${stats.roi.toFixed(1)}%
• Lucro Total Gerado: R$ ${stats.total_profit.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
• Apostas Vencedoras: ${stats.green_bets.toLocaleString('pt-BR')} GREEN de ${stats.total_bets.toLocaleString('pt-BR')}
• Cashouts Realizados: ${stats.cashout_bets.toLocaleString('pt-BR')}

💰 MÉTRICAS DE NEGÓCIO:
• Ticket Médio por Aposta: R$ ${avgTicket.toFixed(2)}
• LTV Estimado por Usuário: R$ ${lifetimeValue.toFixed(2)}/ano
• Total em Despesas Registradas: R$ ${stats.total_expenses.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
• Economia Gerada (Lucro - Despesas): R$ ${(stats.total_profit - stats.total_expenses).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}

📈 DISTRIBUIÇÃO DE RESULTADOS:
• Apostas GREEN: ${stats.green_bets} (${stats.total_bets > 0 ? ((stats.green_bets/stats.total_bets)*100).toFixed(1) : 0}%)
• Apostas RED: ${stats.red_bets} (${stats.total_bets > 0 ? ((stats.red_bets/stats.total_bets)*100).toFixed(1) : 0}%)
• Apostas VOID: ${stats.void_bets} (${stats.total_bets > 0 ? ((stats.void_bets/stats.total_bets)*100).toFixed(1) : 0}%)
• Apostas CASHOUT: ${stats.cashout_bets} (${stats.total_bets > 0 ? ((stats.cashout_bets/stats.total_bets)*100).toFixed(1) : 0}%)

💡 COPY BASEADO EM DADOS REAIS:
"${stats.total_users}+ usuários já confiam no StakeMind!
✅ ${stats.win_rate.toFixed(1)}% de taxa de acerto real
✅ R$ ${(stats.total_profit/1000).toFixed(0)}k+ em lucros reais gerados
✅ ${stats.total_bets}+ apostas registradas e analisadas
✅ Sistema testado e aprovado por apostadores reais"

📱 DADOS TÉCNICOS PARA CAMPANHAS:
• Base ativa: ${stats.active_users} usuários engajados
• Volume médio: R$ ${avgTicket.toFixed(2)} por operação
• ROI comprovado: ${stats.roi.toFixed(1)}% em dados reais
• Economia comprovada: R$ ${((stats.total_profit - stats.total_expenses)/1000).toFixed(1)}k+ para os usuários

🎯 STATUS: DADOS 100% REAIS DA PLATAFORMA EM PRODUÇÃO
📅 Atualizado em: ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`;

    setMarketingData(marketingText);
  };

  const copyMarketingData = () => {
    navigator.clipboard.writeText(marketingData);
    alert('Dados REAIS de marketing copiados para a área de transferência!');
  };

  const formatCurrency = (value) => {
    if (isPrivacyMode) return 'R$ •••••';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  const formatNumber = (value) => {
    if (isPrivacyMode) return '•••••';
    return value.toLocaleString('pt-BR');
  };

  const downloadStoryCard = async () => {
    if (!storyCardRef.current) {
      alert('Card não encontrado. Aguarde o carregamento dos dados.');
      return;
    }
    
    // Verificar se os dados foram carregados
    if (stats.total_bets === 0 && stats.total_users === 0) {
      alert('⚠️ Aguarde o carregamento dos dados antes de baixar a imagem!');
      return;
    }
    
    setDownloading(true);
    const wasPrivacyMode = isPrivacyMode;
    
    try {
      console.log('📸 Iniciando captura do card...');
      console.log('📊 Stats atuais:', stats);
      console.log('📊 Total Units:', stats.total_units);
      console.log('📊 Total Bets:', stats.total_bets);
      
      // Desabilitar modo privacidade temporariamente para captura
      if (isPrivacyMode) {
        setIsPrivacyMode(false);
        console.log('🔓 Modo privacidade desabilitado para captura');
      }
      
      // Mover elemento para dentro da tela
      const element = storyCardRef.current;
      const originalPosition = element.style.left;
      element.style.left = '0px';
      element.style.top = '0px';
      element.style.position = 'fixed';
      element.style.zIndex = '9999';
      
      // Aguardar renderização completa
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      console.log('📸 Iniciando html2canvas...');
      const canvas = await html2canvas(element, {
        scale: 2,
        backgroundColor: '#020617',
        logging: false,
        useCORS: false,
        allowTaint: false,
        width: 1080,
        height: 1920,
        windowWidth: 1080,
        windowHeight: 1920
      });
      
      // Restaurar posição original
      element.style.left = originalPosition;
      element.style.position = 'absolute';
      element.style.zIndex = 'auto';
      
      const link = document.createElement('a');
      link.download = `stakemind-story-${getPeriodLabel().replace(/\s+/g, '-').toLowerCase()}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
      
      console.log('✅ Imagem gerada com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar imagem:', error);
      alert('Erro ao gerar imagem: ' + error.message);
    } finally {
      // Restaurar modo privacidade
      if (wasPrivacyMode) {
        setIsPrivacyMode(true);
      }
      setDownloading(false);
    }
  };

  const getPeriodLabel = () => {
    const now = new Date();
    
    if (selectedPeriod === 'current_month') {
      const monthName = now.toLocaleDateString('pt-BR', { month: 'long' }).toUpperCase();
      return monthName;
    }
    
    if (selectedPeriod === 'last_month') {
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const monthName = lastMonth.toLocaleDateString('pt-BR', { month: 'long' }).toUpperCase();
      return monthName;
    }
    
    if (selectedPeriod === 'last_3_months') {
      const month3Ago = new Date(now.getFullYear(), now.getMonth() - 2, 1);
      const month3Name = month3Ago.toLocaleDateString('pt-BR', { month: 'short' }).toUpperCase();
      const monthNowName = now.toLocaleDateString('pt-BR', { month: 'short' }).toUpperCase();
      return `${month3Name} - ${monthNowName}`;
    }
    
    if (selectedPeriod === 'all_time') {
      return 'TODO PERÍODO';
    }
    
    if (selectedPeriod === 'custom' && customStartDate && customEndDate) {
      const start = new Date(customStartDate);
      const end = new Date(customEndDate);
      const startMonth = start.toLocaleDateString('pt-BR', { month: 'short' }).toUpperCase();
      const endMonth = end.toLocaleDateString('pt-BR', { month: 'short' }).toUpperCase();
      return `${startMonth} - ${endMonth}`;
    }
    
    return 'TODO PERÍODO';
  };

  if (!isAdmin) {
    return (
      <div className="text-center py-12">
        <p className="text-red-500 font-semibold">❌ Acesso negado: Área restrita para administradores</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <p className="text-gray-500 ml-4">📊 Carregando dados reais de todos os usuários...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            📊 Relatórios Marketing com Dados Reais
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Dashboard executivo sincronizado com todos os registros da plataforma
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={downloadStoryCard}
            disabled={downloading}
            className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg hover:from-pink-600 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg font-bold disabled:opacity-50"
          >
            {downloading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Gerando...</span>
              </>
            ) : (
              <>
                <Instagram className="w-5 h-5" />
                <span>Baixar para Story</span>
              </>
            )}
          </button>
          <button
            onClick={() => setIsPrivacyMode(!isPrivacyMode)}
            className="flex items-center space-x-2 px-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            title={isPrivacyMode ? 'Mostrar valores' : 'Ocultar valores'}
          >
            {isPrivacyMode ? (
              <Eye className="w-5 h-5 text-gray-600 dark:text-gray-400" />
            ) : (
              <EyeOff className="w-5 h-5 text-gray-600 dark:text-gray-400" />
            )}
            <span className="text-sm text-gray-600 dark:text-gray-400">
              {isPrivacyMode ? 'Mostrar' : 'Ocultar'}
            </span>
          </button>
          <div className="px-3 py-1 bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-200 text-xs font-semibold rounded-full">
            ✅ DADOS REAIS
          </div>
        </div>
      </div>

      {/* Filtros de Período */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              📅 Filtrar por Período
            </label>
            <select
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
              className="w-full md:w-auto px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="current_month">📅 Mês Atual</option>
              <option value="last_month">📆 Mês Anterior</option>
              <option value="last_3_months">📊 Últimos 3 Meses</option>
              <option value="all_time">🌐 Todo o Período</option>
              <option value="custom">🎯 Período Personalizado</option>
            </select>
          </div>
          
          {selectedPeriod === 'custom' && (
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 flex-1">
              <input
                type="date"
                value={customStartDate}
                onChange={(e) => setCustomStartDate(e.target.value)}
                className="w-full sm:w-auto px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Data inicial"
              />
              <span className="hidden sm:inline text-gray-500 dark:text-gray-400">até</span>
              <input
                type="date"
                value={customEndDate}
                onChange={(e) => setCustomEndDate(e.target.value)}
                className="w-full sm:w-auto px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Data final"
              />
            </div>
          )}
          
          <div className="text-sm text-gray-600 dark:text-gray-400 bg-blue-50 dark:bg-blue-900/20 px-4 py-2 rounded-lg">
            {selectedPeriod === 'current_month' && '📊 Mostrando dados do mês atual'}
            {selectedPeriod === 'last_month' && '📊 Mostrando dados do mês passado'}
            {selectedPeriod === 'last_3_months' && '📊 Mostrando dados dos últimos 3 meses'}
            {selectedPeriod === 'all_time' && '📊 Mostrando dados de todo o período'}
            {selectedPeriod === 'custom' && customStartDate && customEndDate && 
              `📊 ${new Date(customStartDate).toLocaleDateString('pt-BR')} - ${new Date(customEndDate).toLocaleDateString('pt-BR')}`
            }
          </div>
        </div>
      </div>

      {/* KPIs Principais com Dados Reais */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {/* Total de Usuários */}
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100 text-sm font-medium">Total de Usuários REAIS</p>
              <p className="text-3xl font-bold">{formatNumber(stats.total_users)}</p>
              <p className="text-blue-200 text-xs mt-1">Registrados na base</p>
            </div>
            <Users className="w-12 h-12 text-blue-200" />
          </div>
        </div>

        {/* Usuários Ativos */}
        <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100 text-sm font-medium">Usuários Ativos (30d)</p>
              <p className="text-3xl font-bold">{formatNumber(stats.active_users)}</p>
              <p className="text-green-200 text-xs mt-1">
                {stats.total_users > 0 ? ((stats.active_users/stats.total_users)*100).toFixed(1) : 0}% da base
              </p>
            </div>
            <Activity className="w-12 h-12 text-green-200" />
          </div>
        </div>

        {/* Volume Real */}
        <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100 text-sm font-medium">Volume Real Movimentado</p>
              <p className="text-3xl font-bold">{formatCurrency(stats.total_volume).replace('R$ ', 'R$ ')}</p>
              <p className="text-purple-200 text-xs mt-1">{formatNumber(stats.total_bets)} apostas</p>
            </div>
            <DollarSign className="w-12 h-12 text-purple-200" />
          </div>
        </div>

        {/* ROI Real */}
        <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl p-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-orange-100 text-sm font-medium">ROI Real da Base</p>
              <p className="text-3xl font-bold">{isPrivacyMode ? '••••%' : `${stats.roi.toFixed(1)}%`}</p>
              <p className="text-orange-200 text-xs mt-1">Taxa: {isPrivacyMode ? '••••%' : `${stats.win_rate.toFixed(1)}%`}</p>
            </div>
            <TrendingUp className="w-12 h-12 text-orange-200" />
          </div>
        </div>

        {/* Total de Unidades */}
        <div className="bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-xl p-6 text-white shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-cyan-100 text-sm font-medium">Total de Unidades</p>
              <p className="text-3xl font-bold">{formatNumber(stats.total_units)}</p>
              <p className="text-cyan-200 text-xs mt-1">Período selecionado</p>
            </div>
            <Zap className="w-12 h-12 text-cyan-200" />
          </div>
        </div>
      </div>

      {/* Distribuição Real de Resultados */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <Target className="w-5 h-5 mr-2 text-green-600" />
          📊 Distribuição REAL de Resultados
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { key: 'green_bets', label: 'GREEN', value: stats.green_bets, color: 'from-green-500 to-green-600', textColor: 'text-green-600' },
            { key: 'red_bets', label: 'RED', value: stats.red_bets, color: 'from-red-500 to-red-600', textColor: 'text-red-600' },
            { key: 'void_bets', label: 'VOID', value: stats.void_bets, color: 'from-gray-500 to-gray-600', textColor: 'text-gray-600' },
            { key: 'cashout_bets', label: 'CASHOUT', value: stats.cashout_bets, color: 'from-blue-500 to-blue-600', textColor: 'text-blue-600' }
          ].map((result, index) => (
            <div key={index} className="text-center p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
              <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${result.color} flex items-center justify-center mx-auto mb-2`}>
                <BarChart3 className="w-6 h-6 text-white" />
              </div>
              <h4 className="font-medium text-gray-900 dark:text-white text-sm mb-1">{result.label}</h4>
              <p className={`text-2xl font-bold ${result.textColor}`}>{formatNumber(result.value)}</p>
              <p className="text-xs text-gray-500">
                {stats.total_bets > 0 ? ((result.value/stats.total_bets)*100).toFixed(1) : 0}% do total
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Resumo Financeiro Real */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="bg-gradient-to-br from-emerald-50 to-green-50 dark:from-emerald-900/20 dark:to-green-900/20 border border-emerald-200 dark:border-emerald-800 rounded-xl p-6">
          <h4 className="font-semibold text-emerald-800 dark:text-emerald-200 mb-2">💰 Lucro Total dos Usuários</h4>
          <p className="text-3xl font-bold text-emerald-600 dark:text-emerald-400">{formatCurrency(stats.total_profit)}</p>
          <p className="text-sm text-emerald-600 dark:text-emerald-400 mt-1">Valor real gerado pela base</p>
        </div>

        <div className="bg-gradient-to-br from-red-50 to-pink-50 dark:from-red-900/20 dark:to-pink-900/20 border border-red-200 dark:border-red-800 rounded-xl p-6">
          <h4 className="font-semibold text-red-800 dark:text-red-200 mb-2">📉 Total em Despesas</h4>
          <p className="text-3xl font-bold text-red-600 dark:text-red-400">{formatCurrency(stats.total_expenses)}</p>
          <p className="text-sm text-red-600 dark:text-red-400 mt-1">Gastos registrados pelos usuários</p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-6">
          <h4 className="font-semibold text-blue-800 dark:text-blue-200 mb-2">💎 Economia Líquida</h4>
          <p className="text-3xl font-bold text-blue-600 dark:text-blue-400">
            {formatCurrency(stats.total_profit - stats.total_expenses)}
          </p>
          <p className="text-sm text-blue-600 dark:text-blue-400 mt-1">Lucros - Despesas (valor real)</p>
        </div>
      </div>

      {/* Card Oculto para Download Story (9:16) */}
      <div 
        ref={storyCardRef}
        style={{ 
          position: 'absolute',
          left: '-9999px',
          width: '1080px',
          height: '1920px',
          overflow: 'hidden'
        }}
        className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950"
      >
        <div className="relative w-full h-full flex flex-col p-14 overflow-hidden">
          {/* Background Effects */}
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-blue-500/20 to-purple-500/10"></div>
          <div className="absolute top-40 left-40 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-40 right-40 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl"></div>
          
          {/* Content */}
          <div className="relative z-10 flex flex-col h-full justify-center">
            {/* Espaço para Logo (adicionar manualmente) */}
            <div style={{ height: '200px', marginBottom: '32px' }}></div>
            
            {/* Title */}
            <div className="text-center" style={{ marginBottom: '32px' }}>
              <div className="text-4xl font-bold text-white mb-2">
                RELATÓRIO STAKE MIND
              </div>
              <div className="text-3xl font-semibold text-cyan-400">
                {getPeriodLabel().toUpperCase()}
              </div>
            </div>

            {/* Grid Stats - 4 Cards Relevantes em 2x2 */}
            <div className="grid grid-cols-2 gap-6" style={{ marginBottom: '32px' }}>
              {/* Apostas Totais */}
              <div className="bg-gradient-to-br from-purple-500/20 to-pink-600/20 border-2 border-purple-500/40 rounded-3xl p-9 text-center flex flex-col justify-center" style={{ minHeight: '190px' }}>
                <div className="text-5xl font-black text-white mb-4">
                  {stats.total_bets || 0}
                </div>
                <div className="text-2xl font-bold text-purple-300 mb-2">
                  APOSTAS
                </div>
                <div className="text-lg text-gray-400">
                  Registradas
                </div>
              </div>

              {/* Volume Movimentado */}
              <div className="bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border-2 border-cyan-500/40 rounded-3xl p-9 text-center flex flex-col justify-center" style={{ minHeight: '190px' }}>
                <div className="text-4xl font-black text-white mb-4">
                  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(stats.total_volume || 0).replace(',00', '')}
                </div>
                <div className="text-2xl font-bold text-cyan-300 mb-2">
                  VOLUME
                </div>
                <div className="text-lg text-gray-400">
                  Total
                </div>
              </div>

              {/* Taxa de Acerto */}
              <div className="bg-gradient-to-br from-blue-500/20 to-indigo-600/20 border-2 border-blue-500/40 rounded-3xl p-9 text-center flex flex-col justify-center" style={{ minHeight: '190px' }}>
                <div className="text-5xl font-black text-white mb-4">
                  {(stats.win_rate || 0).toFixed(1)}%
                </div>
                <div className="text-2xl font-bold text-blue-300 mb-2">
                  WIN RATE
                </div>
                <div className="text-lg text-gray-400">
                  Taxa de Acerto
                </div>
              </div>

              {/* ROI */}
              <div className={`bg-gradient-to-br ${(stats.roi || 0) >= 0 ? 'from-green-500/20 to-emerald-600/20 border-green-500/40' : 'from-red-500/20 to-orange-600/20 border-red-500/40'} border-2 rounded-3xl p-9 text-center flex flex-col justify-center`} style={{ minHeight: '190px' }}>
                <div className={`text-5xl font-black mb-4 ${(stats.roi || 0) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                  {(stats.roi || 0) >= 0 ? '+' : ''}{(stats.roi || 0).toFixed(1)}%
                </div>
                <div className={`text-2xl font-bold mb-2 ${(stats.roi || 0) >= 0 ? 'text-green-300' : 'text-red-300'}`}>
                  ROI
                </div>
                <div className="text-lg text-gray-400">
                  Retorno
                </div>
              </div>
            </div>

            {/* Unidades em Destaque */}
            <div className={`bg-gradient-to-r ${(stats.total_units || 0) >= 0 ? 'from-green-500/20 via-emerald-500/20 to-green-600/20 border-green-500/40' : 'from-red-500/20 via-orange-500/20 to-red-600/20 border-red-500/40'} border-4 rounded-3xl p-14 text-center`} style={{ minHeight: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: '32px' }}>
              <div className={`text-7xl font-black mb-5 ${(stats.total_units || 0) >= 0 ? 'text-green-400' : 'text-red-400'}`} style={{ 
                textShadow: (stats.total_units || 0) >= 0 ? '0 0 40px rgba(34, 197, 94, 0.7)' : '0 0 40px rgba(239, 68, 68, 0.7)',
                lineHeight: '1.1'
              }}>
                {(stats.total_units || 0) >= 0 ? '+' : ''}{stats.total_units || 0}
              </div>
              <div className={`text-3xl font-bold mb-3 ${(stats.total_units || 0) >= 0 ? 'text-green-300' : 'text-red-300'}`}>
                UNIDADES LÍQUIDAS
              </div>
              <div className="text-xl text-gray-300">
                Apostas Vencedoras
              </div>
            </div>

            {/* Footer */}
            <div className="text-center">
              <div className="text-3xl font-bold text-cyan-400 mb-3">
                stakemind.com.br
              </div>
              <div className="text-xl text-gray-400">
                Sistema Profissional de Gestão de Apostas
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminReports;